import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

/**
 * Bir TARİHE hangi dönemin ait olduğunu bulur.
 *
 * NEDEN VAR: Aynı şubede birden fazla dönemin aynı anda aktif olması DOĞRU ve
 * isteniyor — eski dönem devam ederken yeni döneme kayıt toplanmaya başlıyor.
 * Ama ekranlar bunu desteklemiyordu: hepsi "aktif dönemlerin ilki"ni alıyordu
 * ve /terms `start_date desc` sıraladığı için bu her zaman EN GEÇ BAŞLAYAN
 * dönem oluyordu. Yeni dönem eklenir eklenmez varsayılan sessizce ona kaydı.
 *
 * Somut sonucu: 13 Ağustos'a, 7 Eylül'de başlayan döneme bağlı bir telafi
 * dersi açıldı. Üstelik kod `|| terms[0]` yedeğiyle "kapsayan dönem yok" hata
 * mesajını da hiç göstermiyordu — liste boş olmadıkça yedek hep devreye
 * giriyordu.
 *
 * Kural: ölçüt KAYDIN YAPILDIĞI SEANS TARİHİ. "Bugün" değil — ileri tarihli
 * bir seansa kayıt yapılırken doğru olan seans tarihidir.
 */

/** Verilen tarihi [start_date, end_date] aralığında kapsayan dönemler. */
export const termsCoveringDate = (terms, date) => {
  if (!date || !Array.isArray(terms)) return [];
  const d = dayjs(date);
  return terms.filter(t =>
    t?.start_date && t?.end_date && d.isBetween(t.start_date, t.end_date, 'day', '[]')
  );
};

/**
 * Tarihi kapsayan dönemlerden birini seçer.
 *
 * Birden fazla kapsayan dönem varsa EN ERKEN BAŞLAYAN seçilir: o, hâlihazırda
 * yürüyen dönemdir. Yeni açılmış dönem ileriye dönük kayıt topluyor, bugünkü
 * bir telafi dersi ona ait değil.
 *
 * Kapsayan dönem yoksa null döner — çağıran taraf kaydı YAPMAMALI. Eski
 * `|| terms[0]` yedeği tam olarak buydu ve hatalı kaydın sebebiydi; geri
 * eklemeyin.
 */
export const pickTermForDate = (terms, date) => {
  const kapsayan = termsCoveringDate(terms, date);
  if (kapsayan.length === 0) return null;

  return [...kapsayan].sort((a, b) => dayjs(a.start_date).valueOf() - dayjs(b.start_date).valueOf())[0];
};

/** Kapsayan dönem bulunamadığında kullanıcıya gösterilecek mesaj. */
export const noTermMessage = (date) =>
  `${dayjs(date).format('DD.MM.YYYY')} tarihi hiçbir aktif dönemin içinde değil. `
  + 'Kayıt yapılamaz — önce bu tarihi kapsayan bir dönem tanımlanmalı.';
